import api from "../../../api/comptabilite/_exploitation";

const state = () => ({
    recap_consultation_generaliste: [],
    recap_consultation_specialiste: [],
    liste_recap_consultation_gen: [],
    liste_recap_consultation_spec: [],
    liste_patient_by_type_consultation: [],

    recap_analyse: [],
    liste_recap_analyse: [],
    liste_patient_by_analyse: [],

    recap_examen: [],
    liste_recap_examen: [],
    liste_patient_by_examen: [],

    recap_medicament: [],
    liste_recap_medicament: [],
    liste_patient_by_medicament: [],

    recap_injectable: [],
    liste_recap_injectable: [],
    liste_patient_by_injectable: [],

    recap_consommable: [],
    liste_recap_consommable: [],
    liste_patient_by_consommable: [],

    recap_soin: [],
    liste_recap_soin: [],
    liste_patient_by_soin: [],

    recap_bon_consommable: [],
    liste_recap_bon_consommable: [],
    liste_patient_by_bon_consommable: [],

    recap_admission: [],
    liste_recap_admission: [],
    liste_patient_by_admission: [],
});

// getters
const getters = {
    recap_consultation_generaliste: (state) => {
        return state.recap_consultation_generaliste;
    },

    recap_consultation_specialiste: (state) => {
        return state.recap_consultation_specialiste;
    },

    liste_recap_consultation_gen: (state) => {
        return state.liste_recap_consultation_gen;
    },

    liste_recap_consultation_spec: (state) => {
        return state.liste_recap_consultation_spec;
    },

    liste_patient_by_type_consultation: (state) => {
        return state.liste_patient_by_type_consultation;
    },

    recap_analyse: (state) => {
        return state.recap_analyse;
    },

    liste_recap_analyse: (state) => {
        return state.liste_recap_analyse;
    },

    liste_patient_by_analyse: (state) => {
        return state.liste_patient_by_analyse;
    },

    recap_examen: (state) => {
        return state.recap_examen;
    },

    liste_recap_examen: (state) => {
        return state.liste_recap_examen;
    },

    liste_patient_by_examen: (state) => {
        return state.liste_patient_by_examen;
    },

    recap_medicament: (state) => {
        return state.recap_medicament;
    },

    liste_recap_medicament: (state) => {
        return state.liste_recap_medicament;
    },

    liste_patient_by_medicament: (state) => {
        return state.liste_patient_by_medicament;
    },

    recap_injectable: (state) => {
        return state.recap_injectable;
    },

    liste_recap_injectable: (state) => {
        return state.liste_recap_injectable;
    },

    liste_patient_by_injectable: (state) => {
        return state.liste_patient_by_injectable;
    },

    recap_consommable: (state) => {
        return state.recap_consommable;
    },

    liste_recap_consommable: (state) => {
        return state.liste_recap_consommable;
    },

    liste_patient_by_consommable: (state) => {
        return state.liste_patient_by_consommable;
    },

    recap_soin: (state) => {
        return state.recap_soin;
    },

    liste_recap_soin: (state) => {
        return state.liste_recap_soin;
    },

    liste_patient_by_soin: (state) => {
        return state.liste_patient_by_soin;
    },

    // Bon consommable
    recap_bon_consommable: (state) => {
        return state.recap_bon_consommable;
    },

    liste_recap_bon_consommable: (state) => {
        return state.liste_recap_bon_consommable;
    },

    liste_patient_by_bon_consommable: (state) => {
        return state.liste_patient_by_bon_consommable;
    },

    // Admission
    recap_admission: (state) => {
        return state.recap_admission;
    },

    liste_recap_admission: (state) => {
        return state.liste_recap_admission;
    },

    liste_patient_by_admission: (state) => {
        return state.liste_patient_by_admission;
    },
};
// mutations
const mutations = {
    SET_RECAP_CONSULTATION_GENERALISTE(state, recap) {
        state.recap_consultation_generaliste = recap;
    },

    SET_RECAP_CONSULTATION_SPECIALISTE(state, recap) {
        state.recap_consultation_specialiste = recap;
    },

    SET_LISTE_RECAP_CONSULTATION_GENERALISTE(state, l_recap) {
        state.liste_recap_consultation_gen = l_recap;
    },

    SET_LISTE_RECAP_CONSULTATION_SPECIALISTE(state, l_recap) {
        state.liste_recap_consultation_spec = l_recap;
    },

    SET_LISTE_PATIENT_BY_TYPE_CONSULTATION(state, patients) {
        state.liste_patient_by_type_consultation = patients;
    },

    SET_RECAP_ANALYSE(state, recap) {
        state.recap_analyse = recap;
    },

    SET_LISTE_RECAP_ANALYSE(state, l_recap) {
        state.liste_recap_analyse = l_recap;
    },

    SET_LISTE_PATIENT_BY_ANALYSE(state, patients) {
        state.liste_patient_by_analyse = patients;
    },

    SET_RECAP_EXAMEN(state, recap) {
        state.recap_examen = recap;
    },

    SET_LISTE_RECAP_EXAMEN(state, l_recap) {
        state.liste_recap_examen = l_recap;
    },

    SET_LISTE_PATIENT_BY_EXAMEN(state, patients) {
        state.liste_patient_by_examen = patients;
    },

    SET_RECAP_MEDICAMENT(state, recap) {
        state.recap_medicament = recap;
    },

    SET_LISTE_RECAP_MEDICAMENT(state, l_recap) {
        state.liste_recap_medicament = l_recap;
    },

    SET_LISTE_PATIENT_BY_MEDICAMENT(state, l_patient) {
        state.liste_patient_by_medicament = l_patient;
    },

    SET_RECAP_INJECTABLE(state, recap) {
        state.recap_injectable = recap;
    },

    SET_LISTE_RECAP_INJECTABLE(state, l_recap) {
        state.liste_recap_injectable = l_recap;
    },

    SET_LISTE_PATIENT_BY_INJECTABLE(state, l_patient) {
        state.liste_patient_by_injectable = l_patient;
    },

    SET_RECAP_CONSOMMABLE(state, recap) {
        state.recap_consommable = recap;
    },

    SET_LISTE_RECAP_CONSOMMABLE(state, l_recap) {
        state.liste_recap_consommable = l_recap;
    },

    SET_LISTE_PATIENT_BY_CONSOMMABLE(state, l_patient) {
        state.liste_patient_by_consommable = l_patient;
    },

    SET_RECAP_SOIN(state, recap) {
        state.recap_soin = recap;
    },

    SET_LISTE_RECAP_SOIN(state, liste) {
        state.liste_recap_soin = liste;
    },

    SET_LISTE_PATIENT_BY_SOIN(state, patient) {
        state.liste_patient_by_soin = patient;
    },

    // Bon de consommble
    SET_RECAP_BON_CONSOMMABLE(state, recap) {
        state.recap_bon_consommable = recap;
    },

    SET_LISTE_RECAP_BON_CONSOMMABLE(state, liste) {
        state.liste_recap_bon_consommable = liste;
    },

    SET_LISTE_PATIENT_BY_BON_CONSOMMABLE(state, patient) {
        state.liste_patient_by_bon_consommable = patient;
    },

    // Admission
    SET_RECAP_ADMISSION(state, recap) {
        state.recap_admission = recap;
    },

    SET_LISTE_RECAP_ADMISSION(state, liste) {
        state.liste_recap_admission = liste;
    },

    SET_LISTE_PATIENT_BY_ADMISSION(state, patient) {
        state.liste_patient_by_admission = patient;
    },
};

// actions
const actions = {
    getRecapConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapConsultation(data).then(
                (response) => {
                    if (data.categorie_id == 1) {
                        commit("SET_RECAP_CONSULTATION_GENERALISTE", response);
                    } else if(data.categorie_id == 2) {
                        commit("SET_RECAP_CONSULTATION_SPECIALISTE", response);
                    }
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapConsultation(data).then(
                (response) => {
                    if (data.categorie_id == 1) {
                        commit("SET_LISTE_RECAP_CONSULTATION_GENERALISTE", response);
                    } else if(data.categorie_id == 2) {
                        commit("SET_LISTE_RECAP_CONSULTATION_SPECIALISTE", response);
                    }
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientByTypeConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientByTypeConsultation(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_TYPE_CONSULTATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapAnalyse(data).then(
                (response) => {
                    commit("SET_RECAP_ANALYSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapAnalyse(data).then(
                (response) => {
                    commit("SET_LISTE_RECAP_ANALYSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientAnalyse(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_ANALYSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapExamen(data).then(
                (response) => {
                    commit("SET_RECAP_EXAMEN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapExamen(data).then(
                (response) => {
                    commit("SET_LISTE_RECAP_EXAMEN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientExamen(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_EXAMEN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapArticle({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapArticle(data).then(
                (response) => {
                    if (data.type_article == 1) {           //  Médicaments & Injectables
                        if (data.est_injectable == 0) {
                            commit("SET_RECAP_MEDICAMENT", response);
                        } else {
                            commit("SET_RECAP_INJECTABLE", response);
                        }
                    } else if (data.type_article == 2) {    // Consommables
                        commit("SET_RECAP_CONSOMMABLE", response);
                    }
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapArticle({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapArticle(data).then(
                (response) => {
                    if (data.type_article == 1) {           //  Médicaments & Injectables
                        if (data.est_injectable == 0) {
                            commit("SET_LISTE_RECAP_MEDICAMENT", response);
                        } else {
                            commit("SET_LISTE_RECAP_INJECTABLE", response);
                        }
                    } else if (data.type_article == 2) {    // Consommables
                        commit("SET_LISTE_RECAP_CONSOMMABLE", response);
                    }
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientRecapArticle({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientRecapArticle(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_MEDICAMENT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapSoin({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapSoin(data).then(
                (response) => {
                    commit("SET_RECAP_SOIN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapSoin({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapSoin(data).then(
                (response) => {
                    commit("SET_LISTE_RECAP_SOIN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientRecapSoin({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientRecapSoin(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_SOIN", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapBonConsommable({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapBonConsommable(data).then(
                (response) => {
                    commit("SET_RECAP_BON_CONSOMMABLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapBonConsommable({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapBonConsommable(data).then(
                (response) => {
                    commit("SET_LISTE_RECAP_BON_CONSOMMABLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientBonConsommable({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientBonConsommable(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_BON_CONSOMMABLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapAdmission({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getRecapAdmission(data).then(
                (response) => {
                    commit("SET_RECAP_ADMISSION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapAdmission({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapAdmission(data).then(
                (response) => {
                    commit("SET_LISTE_RECAP_ADMISSION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatientAdmission({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePatientAdmission(data).then(
                (response) => {
                    commit("SET_LISTE_PATIENT_BY_ADMISSION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};